import { render, staticRenderFns } from "./HederDiscountsAll.vue?vue&type=template&id=3651abcc&scoped=true&"
import script from "./HederDiscountsAll.vue?vue&type=script&lang=js&"
export * from "./HederDiscountsAll.vue?vue&type=script&lang=js&"
import style0 from "./HederDiscountsAll.vue?vue&type=style&index=0&id=3651abcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3651abcc",
  null
  
)

export default component.exports